module.exports = __webpack_public_path__ + "img/calling-icon.4318b9f7.png";